<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:0em">This novel is dedicated to the memory of three individuals. The first is Rev. Fr. Reynolds, my English teacher at St. Joseph’s college, Devagiri, in Kozhikode District, Kerala, India. He discovered quite early my flair in writing in English, so much so, when the time came for me to decide on a profession, he suggested that I become a journalist. But fate had other ideas about that. However, even in my chosen profession of medicine, my ability to write had come to my aid. Similarly, my lifelong passion in physics has recently led to my dabbling in astronomy, and in this also my ability in writing has helped.</p><br/>
<p style="text-indent:0em">The second influence in my life was my uncle Koroth Padmanabhan, our ‘Pappettan’. While I was growing up, he instilled in me the curiosity about everything, and of sensible questioning of the status quo. This influence played a large part in my inquisitiveness and objective analysis of facts, rather than blind beliefs in facts as presented by others. Suffice it to say that I have taken all those influences to their logical conclusion, without which, this science-fiction novel and the astronomy-related articles I have authored, could not have been possible.</p><br/>
<p style="text-indent:0em">My third influence was Carl Sagan. I watched with fascination his TV series called ‘Cosmos’ in the early 1980s. His deep knowledge of not only astronomy, but other disciplines of science left a lasting impression on me and gave me the foundation to build on and finally to formulate my own ideas about the universe. It must be appreciated that much of what I discovered through my studies in astronomy ran counter to what Carl Sagan taught and what the current cosmology believes in. I still give him credit for giving me basic education in cosmology, perking my interest in this branch of science and, in some respects, leading to my discoveries in astronomy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?190221bf